export const manfrediteOnboardingStatusResponseMock = {
    data: {
        status: 'uncompleted',
        step: {
            name: 'input_full_name',
            payload: {
                first_name: 'Bartolomé',
                last_name: 'Sagunto'
            },
            actions: ['FORWARD', 'BACKWARD'],
            context: {
                steps: ['input_full_name', 'input_headline_bio'],
            }
        }
    },
    message: 'getManfrediteOnboardingStatus',
    lang: 'MOCK'
};
//# sourceMappingURL=manfredite-onboarding-status.mocks.js.map